import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, TrendingUpIcon, UsersIcon, ClockIcon, RefreshCwIcon, CheckCircleIcon } from 'lucide-react';
export function CaseStudy6() {
  return <div data-id="element-902">
      <section className="bg-gradient-to-r from-[#0096B4] to-[#7DCCD8] text-white py-16" data-id="element-903">
        <div className="container mx-auto px-4" data-id="element-904">
          <Link to="/" className="inline-flex items-center text-white hover:text-[#E0F5F8] mb-6 transition-colors duration-200" data-id="element-905">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-906" />
            Back to Home
          </Link>
          <h1 className="text-4xl font-bold mb-4" data-id="element-907">
            Agile Product Innovation & Rescue
          </h1>
          <p className="text-xl mb-6 text-white max-w-3xl" data-id="element-908">
            How I saved a pre-launch product with negative retailer feedback by
            implementing agile methodology and co-creating with key opinion
            leaders, driving a complete turnaround in just two weeks.
          </p>
          <div className="flex flex-wrap gap-6 mt-8" data-id="element-909">
            <div className="flex items-center" data-id="element-910">
              <ClockIcon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-911" />
              <span className="text-white" data-id="element-912">2-Week Sprint Turnaround</span>
            </div>
            <div className="flex items-center" data-id="element-913">
              <TrendingUpIcon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-914" />
              <span className="text-white" data-id="element-915">$7M Incremental Sales</span>
            </div>
            <div className="flex items-center" data-id="element-916">
              <RefreshCwIcon size={20} className="mr-2 text-[#E0F5F8]" data-id="element-917" />
              <span className="text-white" data-id="element-918">Agile Methodology</span>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 bg-white" data-id="element-919">
        <div className="container mx-auto px-4" data-id="element-920">
          <div className="max-w-3xl mx-auto" data-id="element-921">
            <div className="mb-12" data-id="element-922">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-923">
                The Challenge
              </h2>
              <p className="text-gray-700 mb-4" data-id="element-924">
                I was onboarded to a project just as a key retailer provided
                unsatisfactory feedback on a product that had been in
                development for over a year.
              </p>
              <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2" data-id="element-925">
                <li data-id="element-926">
                  The product was already committed to Johnson & Johnson's
                  pipeline with significant resources invested
                </li>
                <li data-id="element-927">
                  The launch date was rapidly approaching with distribution
                  challenges threatening its viability
                </li>
                <li data-id="element-928">
                  The organization followed traditional waterfall methodologies,
                  making rapid iteration challenging
                </li>
              </ul>
            </div>
            <div className="mb-12" data-id="element-929">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-930">
                My Approach
              </h2>
              <ol className="list-decimal pl-6 space-y-6" data-id="element-931">
                <li data-id="element-932">
                  <div data-id="element-933">
                    <span className="font-medium text-gray-900" data-id="element-934">
                      Rapid Response Task Force
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1" data-id="element-935">
                      <li data-id="element-936">
                        Organized a cross-functional team with clear Directly
                        Responsible Individuals (DRIs) for each workstream
                      </li>
                      <li data-id="element-937">
                        Held internal cross-functional meeting to analyze
                        retailer feedback and ideate what product features could
                        still be edited within timeline to address retailer's
                        concerns
                      </li>
                    </ul>
                  </div>
                </li>
                <li data-id="element-938">
                  <div data-id="element-939">
                    <span className="font-medium text-gray-900" data-id="element-940">
                      Grassroots Consumer Insights
                    </span>
                    <ul className="list-disc pl-6 mt-2 text-gray-700 space-y-1" data-id="element-941">
                      <li data-id="element-942">
                        Self-initiated and self-led interviews with 32 key
                        opinion leaders (KOLs) to gather rapid feedback
                      </li>
                      <li data-id="element-943">
                        Iteratively revised concept, formula, and claims with
                        key consumer focus groups
                      </li>
                    </ul>
                  </div>
                </li>
              </ol>
            </div>
            <div className="mb-12" data-id="element-944">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-945">
                Execution & Results
              </h2>
              <div className="bg-[#F0FAFC] p-6 rounded-lg mb-8" data-id="element-946">
                <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-947">
                  Key Changes Implemented in Two Weeks:
                </h3>
                <ul className="space-y-3" data-id="element-948">
                  <li className="flex" data-id="element-949">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-950"></div>
                    <div data-id="element-951">
                      <span className="font-medium text-gray-900" data-id="element-952">
                        Completely Repositioned Value Proposition
                      </span>
                      <p className="text-gray-700" data-id="element-953">
                        Shifted from technology-focused messaging to
                        benefit-driven positioning that addressed specific
                        consumer pain points
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-954">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-955"></div>
                    <div data-id="element-956">
                      <span className="font-medium text-gray-900" data-id="element-957">
                        Updated Graphics & Packaging
                      </span>
                      <p className="text-gray-700" data-id="element-958">
                        Redesigned visual elements to better communicate key
                        benefits and improve shelf presence
                      </p>
                    </div>
                  </li>
                  <li className="flex" data-id="element-959">
                    <div className="w-2 h-2 rounded-full bg-[#0096B4] mt-2 mr-3" data-id="element-960"></div>
                    <div data-id="element-961">
                      <span className="font-medium text-gray-900" data-id="element-962">
                        Formula Enhancements
                      </span>
                      <p className="text-gray-700" data-id="element-963">
                        Added key ingredients identified by KOLs as important to
                        target consumers, based on R&D's direct involvement in
                        consumer research
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-3" data-id="element-964">
                Impact:
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6" data-id="element-965">
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-966">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-967">
                    180°
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-968">
                    Retailer Sentiment Shift
                  </div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-969">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-970">
                    $7M
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-971">Incremental Sales</div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-972">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-973">
                    3
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-974">
                    Months Accelerated Timeline
                  </div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-975">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-976">
                    +
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-977">Incremental SKUs</div>
                </div>
                <div className="bg-[#E0F5F8] p-4 rounded-lg text-center" data-id="element-978">
                  <div className="text-3xl font-bold text-[#0096B4] mb-1" data-id="element-979">
                    ✓
                  </div>
                  <div className="text-sm text-gray-700" data-id="element-980">
                    Platform Exclusivity
                  </div>
                </div>
              </div>
              <p className="text-gray-700" data-id="element-981">
                The reimagined product concept received an overwhelmingly
                positive response from the retailer, resulting in a complete
                180° turnaround in sentiment. The buyer requested incremental
                SKUs beyond the original plan, accelerated the ship-to-trade
                date by 3 months, and requested platform exclusivity, providing
                incremental display support. The product generated $7M in
                incremental sales beyond initial forecasts and received
                significant media recognition, including features in USA Today.
              </p>
            </div>
            <div data-id="element-982">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-983">
                Key Learnings
              </h2>
              <ol className="list-decimal pl-6 space-y-4" data-id="element-984">
                <li data-id="element-985">
                  <div data-id="element-986">
                    <span className="font-medium text-gray-900" data-id="element-987">
                      Agile methodology can work in large companies
                    </span>
                    <p className="text-gray-700" data-id="element-988">
                      We demonstrated that with the right approach and
                      leadership, even a large corporation can be nimble and
                      responsive to market feedback, challenging the "we've
                      always done it this way" mentality.
                    </p>
                  </div>
                </li>
                <li data-id="element-989">
                  <div data-id="element-990">
                    <span className="font-medium text-gray-900" data-id="element-991">
                      Cross-functional collaboration breaks down silos
                    </span>
                    <p className="text-gray-700" data-id="element-992">
                      Direct involvement of R&D in consumer research led to
                      better solutions than the traditional brand-dictated
                      approach, creating a new model for product development.
                    </p>
                  </div>
                </li>
                <li data-id="element-993">
                  <div data-id="element-994">
                    <span className="font-medium text-gray-900" data-id="element-995">
                      Trust and autonomy drive results
                    </span>
                    <p className="text-gray-700" data-id="element-996">
                      By establishing clear responsibilities and giving team
                      members freedom to solve problems, we achieved in two
                      weeks what would typically take months in a traditional
                      waterfall process.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 bg-[#F0FAFC]" data-id="element-997">
        <div className="container mx-auto px-4" data-id="element-998">
          <div className="max-w-3xl mx-auto" data-id="element-999">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1000">
              More Case Studies
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1001">
              <Link to="/case-study-5" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200" data-id="element-1002">
                <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-1003">
                  AI-Driven FinTech Platform
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-1004">
                  Ideated vision, design and product roadmap of new AI-driven
                  interactive FinTech platform.
                </p>
                <span className="text-[#0096B4] font-medium" data-id="element-1005">
                  Read case study →
                </span>
              </Link>
              <Link to="/case-study-9" className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200" data-id="element-1006">
                <h3 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-1007">
                  DTC Product Selection Quiz
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-1008">
                  Rebuilt a DTC guided selling tool by analyzing consumer
                  path-to-purchase and optimizing the algorithm.
                </p>
                <span className="text-[#0096B4] font-medium" data-id="element-1009">
                  Read case study →
                </span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}